import React from 'react';
import { XCircle } from 'lucide-react';

export function ErrorScreen({ error }) {
  return (
    <div className="max-w-2xl mx-auto p-6 bg-gray-50 min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="text-red-600 mb-4">
          <XCircle size={48} className="mx-auto mb-2" />
          <h2 className="text-xl font-bold">Błąd ładowania</h2>
        </div>
        <p className="text-gray-600 mb-4">{error}</p>
        <button 
          onClick={() => window.location.reload()} 
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Spróbuj ponownie
        </button>
      </div>
    </div>
  );
} 